import type { Tab } from "../../routes.ts";

/** Client navigation mirrors the server owner guard; the server remains authoritative. */
export function allowedTab(role: "owner" | "member" | "strategist", tab: Tab, billingOwner = role === "owner"): boolean {
  return tab !== "billing" || billingOwner;
}

export function shouldShowOnboarding(step: number, role: "owner" | "member" | "strategist"): boolean {
  return role === "owner" && step < 5;
}
